import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import TextField from "@mui/material/TextField";
// import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "../../assets/icons/global-icon-search-black.svg";
import SearchCloseIcon from "../../assets/icons/global-icon-black-close.svg";
import SkeletonComp from "app/common/skeleton";
import LinesList from "./linesList";
import Tooltip from "app/common/Tooltip";
import appService from "./../service";
import { useSelector } from "react-redux";
import { RootState } from "app/reducers";
import { MyDigitsActionTypes } from "./actions/index.model";
import { useMediaQuery } from "react-responsive";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-control-${index}`}
      aria-labelledby={`labelled-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function ariaControlsProps(index: number) {
  return {
    id: `labelled-tab-${index}`,
    "aria-controls": `tabpanel-control-${index}`,
  };
}

export default function MLineDetailsTabs(props: any): React.ReactElement {
  const {
    lineDetails,
    tabIndex,
    handleTabsChange,
    onSearchInput,
    searchInputValue,
    loading,
    searchOnFocus,
    closeIcon,
    searchOnFocusAction,
    clearSearchInput,
    count,
    headerLoading,
    isEligibilityLine,
  } = props;

  const [isScrollRequired, setIsScrollRequired] = React.useState(false);
  const apiError = useSelector((state: RootState) =>
    state.app.apiCallsStatus[0]?.status === "error" &&
    state.app.apiCallsStatus[0]?.module ===
      MyDigitsActionTypes.LINE_DETAILS_STATUS
      ? true
      : false
  );
  const isMobile = useMediaQuery({ query: "(max-width:760px)" });

  React.useEffect(() => {
    let moreLines = false;
    if (lineDetails) {
      for (let i = 0; i < lineDetails.length; i++) {
        if (lineDetails[i].lines.length > 13) moreLines = true;
      }
    }
    setIsScrollRequired(moreLines);
  }, [lineDetails]);

  const tabsNames = [
    { id: 0, name: "All lines", tooltip: "View all my lines" },
    { id: 1, name: "Paired Devices", tooltip: "View Paired Devices" },
    { id: 2, name: "Assigned", tooltip: "View lines assigned to me" },
    { id: 3, name: "Unassigned", tooltip: "View lines not assigned to me" },
    {
      id: 4,
      name: "Shared with me",
      tooltip: "View lines that are shared with me by others",
    },
  ];
  return (
    <React.Fragment>
      <Grid item container className="searchtabs">
        <SkeletonComp
          loadData={{ loading: headerLoading, height: 50, width: 301 }}
        >
          <Grid item lg={4}>
            <Tooltip
              title={
                <React.Fragment>
                  {"Search by"}
                  <br /> {"number or line"}
                  <br />
                  {"name"}
                </React.Fragment>
              }
              placement="left"
            >
              <div className="searchMain" tabIndex={0}>
                <img
                  className="searchMainIcon"
                  src={SearchIcon}
                  tabIndex={0}
                  alt={"search"}
                  width="16px"
                  height="16px"
                />
                <input
                  aria-invalid="false"
                  tabIndex={0}
                  id="search"
                  placeholder="Search"
                  type="text"
                  className={`Rectangle searchbox ${
                    searchOnFocus ? "input-focus" : ""
                  }`}
                  value={searchInputValue}
                  onFocus={searchOnFocusAction}
                  onChange={onSearchInput}
                  onKeyUp={onSearchInput}
                  disabled={loading ? true : false}
                />
                {closeIcon && (
                  <img
                    className="searchClose"
                    src={SearchCloseIcon}
                    alt={"SearchCloseIcon"}
                    onClick={clearSearchInput}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        clearSearchInput();
                      }
                    }}
                    tabIndex={0}
                    width="16px"
                    height="16px"
                  />
                )}
                {/* <TextField
                className={`Rectangle searchbox ${
                  searchOnFocus ? "input-focus" : ""
                }`}
                hiddenLabel
                id="search"
                size="small"
                value={searchInputValue}
                placeholder={"Search"}
                onFocus={searchOnFocusAction}
                onChange={onSearchInput}
                onKeyUp={onSearchInput}
                style={{ width: "301px", height: "40px" }}
                tabIndex={2}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" tabIndex={0}>
                      <img
                        src={SearchIcon}
                        tabIndex={1}
                        alt={"search"}
                        width="16px"
                        height="16px"
                      />
                      {closeIcon && (
                        <img
                          className="searchClose"
                          src={SearchCloseIcon}
                          alt={"SearchCloseIcon"}
                          onClick={clearSearchInput}
                          tabIndex={0}
                          width="16px"
                          height="16px"
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                disabled={loading ? true : false}
              />*/}
              </div>
            </Tooltip>
          </Grid>
        </SkeletonComp>
        {!isEligibilityLine && (
          <Grid item lg={8} className="tabsArea">
            {!headerLoading && (
              <Tabs
                className="tabsBar"
                value={tabIndex}
                onChange={handleTabsChange}
                // indicatorColor="secondary"
                // textColor="inherit"
                variant="scrollable"
                scrollButtons={isMobile}
                allowScrollButtonsMobile={isMobile}
              >
                {tabsNames.map((tab: any, index: number) => {
                  return (
                    <Tab
                      className={`First_${tab.id} tabs`}
                      data-indexvalue={tab.id}
                      label={
                        <Tooltip title={tab.tooltip} placement="top">
                          <span tabIndex={0}>{tab.name}</span>
                        </Tooltip>
                      }
                      key={index}
                      disableFocusRipple={true}
                      disableRipple={true}
                      {...ariaControlsProps(tab.id)}
                    />
                  );
                })}
              </Tabs>
            )}
          </Grid>
        )}
      </Grid>
      {!isEligibilityLine && (
        <Grid
          item
          container
          className={`maindata bodystart scroll ${
            isScrollRequired ? "scroll" : ""
          }`}
        >
          <div className="tableMain">
            {tabsNames.map((tab: any, index: number) => {
              let response =
                tab.id === 0
                  ? lineDetails && lineDetails
                  : lineDetails &&
                    lineDetails.filter((i: any) => i.id === tab.id);
              const searchKey = appService.returnMsisdnVariation(
                searchInputValue && searchInputValue.length > 1
                  ? searchInputValue
                  : ""
              );
              return (
                <Typography component={"span"} className="tabhead" key={index}>
                  <TabPanel key={tab} value={tabIndex} index={tab.id}>
                    <LinesList
                      key={tab}
                      data={response}
                      searchKey={searchKey}
                      showSkeleton={loading}
                      count={count}
                      tabId={tab.id}
                    />
                  </TabPanel>
                </Typography>
              );
            })}
          </div>
        </Grid>
      )}
      {isEligibilityLine && (
        <Grid item container className={``}>
          <div className="donot">
            {apiError
              ? `Unable to fetch the lines data. Please try again later!`
              : ` You do not have any eligible lines under your account and no lines shared with you`}
          </div>
        </Grid>
      )}
    </React.Fragment>
  );
}
